import { createAsyncThunk } from '@reduxjs/toolkit';
import { addFoodItemAPI, deleteFoodItemByIdAPI, fetchFoodItemsAPI, updateFoodItemAPI } from './foodItemsAPI';
import { fetchCategory } from '../category/categoryThunk';

// Adding new Food Item for category
export const addFoodItem = createAsyncThunk('food/addFoodItem', async (body, { rejectWithValue }) => {
  try {
    const response = await addFoodItemAPI(body);
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

//Fetching food items
export const fetchAllFoodItems = createAsyncThunk('food/fetchAllFoodItem', async (_, { rejectWithValue }) => {
  try {
    const response = await fetchFoodItemsAPI();
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

/// In your thunks file
export const initializeMenuData = createAsyncThunk(
  'food/fetchAllFoodItem',
  async (_, { dispatch, getState, rejectWithValue }) => {
    try {
      const { category } = getState();

      // 1. Check/Fetch Categories
      if (!category.categories || category.categories.length === 0) {
        await dispatch(fetchCategory()).unwrap();
      }

      // 2. Fetch Food Items
      // We don't necessarily need to unwrap this unless 
      // another action depends on it
      return await dispatch(fetchAllFoodItems()).unwrap();
      
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Deleting food items by id
export const deleteFoodItemById = createAsyncThunk('food/deleteFoodItem', async (id, { rejectWithValue }) => {
    try {
        const response = await deleteFoodItemByIdAPI(id)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

// Updating food items by id
export const updateFoodItem = createAsyncThunk("food/updateFoodItem", async (body , { rejectWithValue }) => {
    try {
        const response = await updateFoodItemAPI(body)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})